import React from 'react'

import styled from 'styled-components'
import { Tooltip } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { AssessmentTooltipContents } from '../AssessmentTooltipContents'

const StyledTooltip = withStyles({
  // White card matching the mobile risk popup; the card itself is drawn by
  // AssessmentTooltipContents, so the tooltip only adds the shadow.
  tooltip: {
    padding: 0,
    maxWidth: 320,
    fontFamily: 'Nunito Sans',
    backgroundColor: '#FFF',
    color: '#000',
    borderRadius: '6px',
    boxShadow: '0px 3px 12px rgba(0, 0, 0, 0.25)',
  },
})(Tooltip)

const ColorBar = styled.div`
  flex: ${(props) => props.length};
  height: 12px;
  background: ${(props) => props.color};

  border-left: 1px solid rgba(26, 25, 25, 0.2);
  border-right: 1px solid rgba(26, 25, 25, 0.2);
  &:hover {
    cursor: pointer;
    height: 18px;
    margin-top: -10px;
    border-left: 1px solid rgba(55, 111, 139, 0.6);
    border-right: 1px solid rgba(55, 111, 139, 0.6);
  }
`

const WrappedColorBar = React.forwardRef((props, ref) => {
  //  Spread the props to the underlying DOM element.
  return <ColorBar {...props} ref={ref} />
})

function Assessment({ product, assessmentGroup, onMouseEnter, onMouseLeave, ...props }) {
  const { color, length } = assessmentGroup

  return (
    <StyledTooltip
      title={
        <AssessmentTooltipContents product={product} assessmentGroup={assessmentGroup} />
      }
      placement="top"
      enterTouchDelay={0}
      leaveTouchDelay={3000}
      {...props}
    >
      <WrappedColorBar
        color={color}
        length={length}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </StyledTooltip>
  )
}

export { Assessment }
